import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import CustomerDueFilters from "./components/CustomerDueFilters";
import CustomerDueTable from "./components/CustomerDueTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { selectAuthInfo } from "../Auth/authSelectors";
import { exportCustomerDueCsv } from "./components/exportCustomerDueCsv";

const { Title } = Typography;

const CustomerDue = () => {
  const dispatch = useDispatch();

  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const authInfo = useSelector(selectAuthInfo);
  const {filters, list, totalBalance } = useSelector((state) => state.customerDue);
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Customer Due Balance Report",
    removeAfterPrint: true,
  });

    const handleDownloadCsv = () => {
    exportCustomerDueCsv({
      list,
      totalBalance,
      filters,
      authInfo,
      title: "Customer Due Balance Report",
      filename: "customer_due_balance",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle">Customer Due Balance Report</Title>
            </div>
          }
 extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CustomerDueFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CustomerDueTable authInfo={authInfo} />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Customer Due Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <CustomerDueTable printMode={true} authInfo={authInfo} />
          )}
        />
      </div>
    </div>
  );
};

export default CustomerDue;